import { ProgressBarCountdown, Text } from '@loadsmart/miranda-react'

import { canConfirmLoad, type Load } from '../../domain/Load'
import {
  formatDeadlineText,
  getHeaderTitle,
  getProgressBarValue,
} from '../../presenter/tenderPresenter'
import { DeadlineWrapper, TitleWrapper } from './LoadDeadline.styles'

const DEFAULT_MAX_PROGRESS_BAR = 100

export type LoadDeadlineProps = {
  load: Load
}

export function LoadDeadline({ load, ...otherProps }: LoadDeadlineProps) {
  const canConfirm = canConfirmLoad(load)

  return (
    <DeadlineWrapper {...otherProps}>
      <TitleWrapper>
        <Text variant="body-md-bold">{getHeaderTitle(load)}</Text>
        {canConfirm && <Text variant="body-md">{formatDeadlineText(load)}</Text>}
      </TitleWrapper>
      {canConfirm && (
        <ProgressBarCountdown max={DEFAULT_MAX_PROGRESS_BAR} value={getProgressBarValue(load)} />
      )}
    </DeadlineWrapper>
  )
}
